import { getIntegrationsDataConfig } from '../../../document-inbox/data/config';

/** Call-time read. An unset profile is not on-prem, matching the app default. */
export function isOnPrem(): boolean {
  return getIntegrationsDataConfig().isOnPrem?.() ?? false;
}
